import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Building2, ChevronRight } from "lucide-react";
import { useAppSelector } from "../../../app/hooks";
import { selectIsOrgOwnerOrAdmin } from "../../authentication/authenticationSlice";
import { ROUTES } from "../../../routes";

/**
 * Settings-page card linking to the organization settings.
 * Hidden from plain-role Instructors.
 */
const OrganizationSettingsLink: React.FC = () => {
  const { t } = useTranslation();
  const isOrgOwnerOrAdmin = useAppSelector(selectIsOrgOwnerOrAdmin);

  if (!isOrgOwnerOrAdmin) {
    return null;
  }

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6 transition-colors hover:border-primary-50/40 dark:hover:border-primary-70/40">
      <div className="mb-4 flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-95 text-primary-50 dark:bg-primary-30 dark:text-primary-80">
          <Building2 size={20} strokeWidth={2} />
        </span>
        <div className="min-w-0">
          <h2 className="text-lg font-semibold leading-tight">{t("settings.organization")}</h2>
          <p className="text-sm text-grey-50 dark:text-grey-70 mt-0.5">
            {t("settings.organizationDescription")}
          </p>
        </div>
      </div>
      <Link
        to={ROUTES.ORGANIZATION_SETTINGS}
        className="flex items-center gap-1 text-primary-40 dark:text-primary-90 hover:underline font-medium"
      >
        <span>{t("settings.organizationDetails")}</span>
        <ChevronRight size={16} />
      </Link>
    </div>
  );
};

export default OrganizationSettingsLink;
